import axios from 'axios';
import { userManagerFactory } from '../services/oidc/utils/userManager';

const api = (apiUrl,amlJavaApi) => ({
  exec: ({ method, data, url,amlJava }) => userManagerFactory().getUser().then((rez) => {
    const reqConfig = {
      method,
      url: `${amlJava ? amlJavaApi:apiUrl}/${url}`,
      withCredentials: true,
      headers: {
        Pragma: 'no-cache',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${rez.access_token}`,
        OrganizationName: localStorage.getItem('orgName'),
        TimeZoneOffset: `${-(new Date().getTimezoneOffset()/60)}`,
      },
    };

    if (method.toLowerCase() === 'get') {
      reqConfig.params = data;
    } else {
      reqConfig.data = data;
    }

    return axios(reqConfig);
  }),
});
export default api;


// WEBPACK FOOTER //
// ./src/api-services/api.js